import { reactive } from "vue";
export const useRoute = reactive({
  route: "/",
  setRoute(route) {
    this.route = route;
  },
  getRoute() {
    return this.route;
  }
});
